// utils/safeHtml.js
// Convertit un texte "riche simple" en HTML sûr
// Stratégie :
// 1) Tout échapper
// 2) Transformer certaines syntaxes texte (puces)
// 3) Ré-autoriser explicitement quelques balises HTML sûres

export function toSafeSimpleHtml(raw = "") {
  // ---------------------------------------------------
  // 1) Échapper TOUT le HTML (sécurité par défaut)
  // ---------------------------------------------------
  const escapeHtml = (s) =>
    s
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  let escaped = escapeHtml(String(raw));

  // ---------------------------------------------------
  // 2) Gestion automatique des listes à puces texte
  //
  // Syntaxe supportée :
  // - item 1
  // - item 2
  //
  // → <ul><li>item 1</li><li>item 2</li></ul>
  // ---------------------------------------------------
  escaped = escaped.replace(
    /(?:^|\n)(?:-\s+.+)(?:\n-\s+.+)*/g,
    (block) => {
      const items = block
        .trim()
        .split(/\n/)
        // Retire le tiret + espace en début de ligne
        .map((line) => line.replace(/^-\s+/, "").trim())
        .filter(Boolean)
        .map((text) => `<li>${text}</li>`)
        .join("");

      return `<ul>${items}</ul>`;
    }
  );

  // ---------------------------------------------------
  // 3) Ré-autoriser explicitement des balises HTML sûres
  // (aucun attribut sauf <a href>)
  // ---------------------------------------------------
  let allowed = escaped;

  // Paragraphes <p>
  allowed = allowed.replace(
    /&lt;(\/?)p&gt;/gi,
    (_, slash) => `<${slash}p>`
  );

    // h1 <h1>
  allowed = allowed.replace(
    /&lt;(\/?)h1&gt;/gi,
    (_, slash) => `<${slash}h1>`
  );

      // h2 <h2>
  allowed = allowed.replace(
    /&lt;(\/?)h2&gt;/gi,
    (_, slash) => `<${slash}h2>`
  );

        // br <br>
  allowed = allowed.replace(
    /&lt;(\/?)br&gt;/gi,
    (_, slash) => `<br${slash}>`
  );

  // Gras <strong>
  allowed = allowed.replace(
    /&lt;(\/?)strong&gt;/gi,
    (_, slash) => `<${slash}strong>`
  );

    // Titre <title>
  allowed = allowed.replace(
    /&lt;(\/?)title&gt;/gi,
    (_, slash) => `<${slash}title>`
  );

  // Italique <em>
  allowed = allowed.replace(
    /&lt;(\/?)em&gt;/gi,
    (_, slash) => `<${slash}em>`
  );

  // Liens <a href="..."> avec validation simple de l'URL
  allowed = allowed.replace(
    /&lt;a\s+href=&quot;([^&]*)&quot;&gt;/gi,
    (match, href) => {
      if (
        href.startsWith("mailto:") ||
        href.startsWith("http://") ||
        href.startsWith("https://") ||
        href.startsWith("/") ||
        href.startsWith("#")
      ) {
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">`;
      }
      // URL non autorisée → on laisse échappé
      return match;
    }
  );
  allowed = allowed.replace(/&lt;\/a&gt;/gi, "</a>");

  // Listes HTML <ul>, <ol>, <li> (sans attributs)
  allowed = allowed.replace(/&lt;(\/?)ul&gt;/gi, (_, s) => `<${s}ul>`);
  allowed = allowed.replace(/&lt;(\/?)ol&gt;/gi, (_, s) => `<${s}ol>`);
  allowed = allowed.replace(/&lt;(\/?)li&gt;/gi, (_, s) => `<${s}li>`);

  // ---------------------------------------------------
  // 4) Sauts de ligne restants → <br/>
  // ---------------------------------------------------
  const withBr = allowed.replace(/\r\n|\r|\n/g, "<br/>");

  return withBr;
}
